module.exports = __webpack_public_path__ + "static/Ellipal-cfac533fc712d7d8507e50a149d41577.png";